import { Box, Grid } from "@mui/material"
import ImageSqureCard from "./imageSqureCard"
import { IMultiImageSqureCard } from "./IMultiImageSqureCard"
import { Store } from "../../../models/store.model"
import { getJwtToken, getTokenTime } from "../../../services/auth.service";


export default function MutliImageSqureCard({ stores, handleClick }: IMultiImageSqureCard) {

    getTokenTime();
    const { token } = getJwtToken();


    return (
        <div className={token ? '  overflow-y-auto h-[calc(100svh-240px)]' : ""}>
            <Grid container
                spacing={2}
                sx={{
                    margin: "auto",
                    flex: 1,
                    paddingInline: "10px",
                    justifyContent: stores.length == 1 ? "flex-start" : "center",
                    background: "var(--bg-color)"
                }}


            >
                {stores?.map((item: Store, index: number) => {
                    return (
                        <Grid xs={6} item key={index} >
                            <ImageSqureCard
                                stores={item}
                                onClick={handleClick}
                            />
                        </Grid>)
                })}
            </Grid>
        </div>
    )
}